const pathname = location.pathname;

/*FVスマホ時*/
const srcPc = document.getElementById("fvImage");
if (window.matchMedia('(max-width: 750px)').matches && srcPc !== null) {
  const srcPn = 'https://cdn.shopify.com/s/files/1/0797/4328/7617/files/fv_phone_a.webp';
  srcPc.src =  srcPn;
}

/*products*/
if (pathname.includes("products")){
  window.addEventListener('load', function(){
    const specification = document.getElementsByClassName("product__accordion accordion quick-add-hidden")[0];
    const produstsParentEl = document.getElementById("MediaGallery-template--21178024034625__main");
    produstsParentEl.appendChild(specification);
    if (window.matchMedia("(min-width: 768px)").matches) {
      document.getElementById("Details-collapsible_tab_WgrFRV-template--21178024034625__main").setAttribute("open","open"); 
    }

    const tax = document.createElement("span");
    tax.textContent = " 税込（送料無料）";
    const yenParent = document.getElementsByClassName("price__regular")[0];
    yenParent.appendChild(tax);
  });
}

/*カート*/
if (pathname.includes("cart")){
  const total = document.getElementsByClassName("totals__total")[0];
  total.textContent = "合計（税込み）";

  const totalText = document.getElementsByClassName("tax-note caption-large rte")[0];
  totalText.textContent = "送料は無料です。";
}
